/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { wasteManagementUrls } from '../appConfig';
import { IOrderExclusion } from '../models/OrderExclusions.model';
import wasteManagementClient from './wasteManagementClient';

export default class OrderExclusionService {
  static getExclusions(
    customerId: number,
    ignoreCache: boolean = false
  ): Promise<Array<IOrderExclusion>> {
    return wasteManagementClient
      .get(wasteManagementUrls.orderExclusion, {
        params: { customerId },
        cache: { ignoreCache },
      })
      .then((resp) => {
        if (resp?.status === 200 && resp.data) {
          return resp.data;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  static createExclusion(
    orderExclusion: IOrderExclusion
  ): Promise<IOrderExclusion> {
    return wasteManagementClient
      .post(wasteManagementUrls.orderExclusion, orderExclusion)
      .then((resp) => {
        if (resp?.status === 200 && resp.data) {
          return resp.data;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  static updateExclusion(
    orderExclusion: IOrderExclusion
  ): Promise<IOrderExclusion> {
    return wasteManagementClient
      .put(wasteManagementUrls.orderExclusion, orderExclusion)
      .then((resp) => {
        if (resp?.status === 200 && resp.data) {
          return resp.data;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  static deleteExclusion(
    exclusionId: number,
    customerId: number
  ): Promise<void> {
    const url =
      wasteManagementUrls.orderExclusion +
      `/exclusionId/${exclusionId}/customer/${customerId}`;
    return wasteManagementClient
      .delete(url)
      .then((resp) => {
        if (resp?.data === 200 && resp.data) {
          return resp.data;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }
}
